module.exports = __webpack_public_path__ + "static/media/11_naga_horse.d6fa8e7e.png";